import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.571 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "28.571",
      height: "20",
      fill: "#00579f",
      rx: "2"
    }, null, -1),
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M12.761 13.468h-1.852l1.158-6.914h1.852zM19.474 6.723a4.7 4.7 0 0 0-1.66-.295c-1.83 0-3.117.942-3.125 2.288-.015.993.922 1.545 1.623 1.876.716.338.96.56.96.86-.007.464-.579.678-1.112.678-.74 0-1.135-.11-1.737-.368l-.244-.11-.26 1.551c.435.191 1.235.36 2.066.368 1.943 0 3.207-.927 3.222-2.361.008-.787-.487-1.39-1.554-1.883-.647-.316-1.044-.53-1.044-.853.008-.295.335-.596 1.066-.596a3.24 3.24 0 0 1 1.38.265l.167.073zM21.935 11.019c.153-.397.74-1.935.74-1.935-.009.015.151-.404.243-.662l.13.596s.35 1.655.426 2.001zm2.286-4.465h-1.433c-.441 0-.777.125-.967.574l-2.75 6.34h1.942l.389-1.037h2.377c.053.243.22 1.037.22 1.037h1.715zM9.363 6.554 7.55 11.269l-.198-.957C7.017 9.21 5.965 8.01 4.792 7.414l1.661 6.047h1.958l2.91-6.907z" }),
      _createElementVNode("path", { d: "M5.867 6.554h-2.98l-.03.14c2.324.573 3.863 1.956 4.495 3.619l-.647-3.178c-.107-.442-.435-.567-.838-.581" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "visa"}) } }